<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(name)="data">
                  {{ data.item.name }}
                </template>
                <template #cell(gender)="data">
                  {{ data.item.gender }}
                </template>
                <template #cell(telephone)="data">
                  0{{ data.item.telephone }}
                </template>
              <template #cell(actions)="data">
                <router-link :to="{ path: '/testreport', query: { id: data.item.visit_id }}" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-printer"></i> view results </router-link>
              </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
// import axios from "axios";
// import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { patienttestresultMethods, patienttestresultComputed } from "@/state/helpers";

export default {
  page: {
    title: "Test Result Reports",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader
  },
  data() {
    return {
      title: "Test Result Reports",
      items: [ {text: "Dashboard",to: "/",}, {text: "Test Result Reports",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'name', label: 'Name', visible: true },
          { key: 'gender', label: 'Gender', visible: true },
          { key: 'telephone', label: 'Telephone', visible: true },
          { key: 'address', label: 'Address', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      testresults:[],
      id:'',
      patient_id:'',
      patient_name:'',
      visit_id:'',
      daterecorded:new Date().toLocaleDateString('fr-CA'),
      result:'',
      test:'',
      testid:'',
    };
  },
  computed: {
    ...patienttestresultComputed,
    List() { return this.patienttestresults.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.patienttestresults.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.patienttestresults.length>0) { a=false;} else { a=true;} return a },
  },
  mounted() {
    this.fetchPatientTestresults();
    this.TotalRows = this.patienttestresults.length;
    this.isBusy=false;
  },
  methods: {
    ...patienttestresultMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
  
  },
};
</script>